import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CommentItem } from '@/shared/components/contracts/CommentsModalContent'
import { selectCurrentContract } from '../../DashboardV2Selectors'
import { dashboardV2Actions } from '../../DashboardV2Sagas'
import { contractToolsActions } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/ContractToolsSagas'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const RETRACTED_STATUSES = ['R0400', 'R0500']

interface UseContractActionsParams {
  contractId: string
  contactZohoId: string
  contractUserId: string
  statusRaw: string
  contactId: string
  getContracts: () => void
  formInitUrl: string
}

const useContractActions = ({
  contractId,
  contactZohoId,
  contractUserId,
  statusRaw,
  contactId,
  getContracts,
  formInitUrl,
}: UseContractActionsParams) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [modalType, setModalType] = useState('')

  const currentContract = useSelector(selectCurrentContract)
  const { userId, isAdmin } = useSelector(selectAuthData) as { userId?: string; isAdmin?: boolean }

  const openModal = (type: string, e: React.MouseEvent) => {
    e.stopPropagation()
    if (type === 'comments') {
      const url = (formInitUrl ?? '').replace('*', contactZohoId)
      dispatch({ type: dashboardV2Actions.LOAD_CONTRACT_DETAILS, url, contactZohoId })
    }
    setModalType(type)
    setIsOpen(true)
  }

  const closeModal = () => {
    getContracts()
    setIsOpen(false)
  }

  const handleAbandonSubmit = (reason: string, callback: (success: boolean) => void) => {
    dispatch({
      type: contractToolsActions.RETRACT_CONTRACT_V2,
      reason,
      id: contractId,
      callback: (_response: unknown, status: number) => {
        const success = status === 200
        callback(success)
        if (success) closeModal()
      },
    })
  }

  const handleCommentSubmit = (comment: string, callback: (success: boolean) => void) => {
    dispatch({
      type: contractToolsActions.ADD_COMMENT_TO_CONTACT_V2,
      comment,
      contactId: contactId,
      callback: (_response: unknown, status: number) => {
        const success = status === 200
        callback(success)
        if (success) closeModal()
      },
    })
  }

  const openContract = (e: React.MouseEvent) => {
    e.stopPropagation()
    window.open('/contact/' + contactZohoId + '#' + contractId, '_blank')
  }

  const isContractLoaded = currentContract?.id === contactZohoId

  return {
    isOpen,
    modalType,
    openContract,
    openAbandon: (e: React.MouseEvent) => openModal('abandon', e),
    openComments: (e: React.MouseEvent) => openModal('comments', e),
    dismissModal: () => setIsOpen(false),
    stopPropagation: (e: React.MouseEvent) => e.stopPropagation(),
    handleAbandonSubmit,
    handleCommentSubmit,
    isLoadingComments: isOpen && modalType === 'comments' && !isContractLoaded,
    comments: isContractLoaded ? ((currentContract?.comments as CommentItem[]) ?? []) : [],
    canAbandon: !RETRACTED_STATUSES.includes(statusRaw) && (isAdmin || contractUserId === userId),
  }
}

export default useContractActions
